export const CCSTORE = {
  UPDATE_CALC_CACHE: 'calcCache/UPDATE_CALC_CACHE',
  UPDATE_COMP_CALC_CACHE: 'calcCache/UPDATE_COMP_CALC_CACHE',
  CLEAR_CACHE: 'calcCache/CLEAR_CACHE',
  UPDATE_BOOKING_CACHE: 'calcCache/UPDATE_BOOKING_CACHE',
} as const;
